import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    display: 'flex',
    alignItems: 'center',
    '&:first-child': {
      paddingTop: theme.spacing(3),
    },
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  circularProgress: {
    color: 'green',
  },
  heading: {
    fontWeight: 600,
  },
}));

export default useStyles;
